import React from 'react';
import { withTranslation } from "react-i18next"
import { ruHtmlContent, zhHtmlContent, enHtmlContent, inHtmlContent, frHtmlContent, esHtmlContent, thHtmlContent, msHtmlContent, ptHtmlContent, viHtmlContent, arHtmlContent } from '../../utils/i18nUtils';

class PrivacyAgreement extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            publicKey:'',
            captchaKey:'',
            captchaImg:'',
            phoneCaptchaKey:'',
            phone:'',
            isLogin: true,
            languageType: localStorage.getItem('languageType'),
            show:false,
            htmlContent:''
        }
    }

    componentDidMount(){ 
        const languageType = localStorage.getItem('languageType');
        let locale = 'zh_CN';
        let htmlContent = zhHtmlContent;
        if(languageType === 'en'){
            locale = 'en_US'
            htmlContent = enHtmlContent
        }else if(languageType === 'ina'){
            locale = 'en_ID'
            htmlContent = inHtmlContent;
        }else if(languageType === 'ru_RU'){
            locale = 'ru_RU'
            htmlContent = ruHtmlContent;
        }else if(languageType === 'es_ES'){
            locale = 'es_ES'
            htmlContent = esHtmlContent;
        }else if(languageType === 'fr_FR'){
            locale = 'fr_FR'
            htmlContent = frHtmlContent;
        }else if(languageType === 'th_TH'){
            locale = 'th_TH'
            htmlContent = thHtmlContent;
        }else if(languageType === 'ms_MS'){
            locale = 'ms_MS'
            htmlContent = msHtmlContent;
        }else if(languageType === 'pt_PT'){
            locale = 'pt_PT'
            htmlContent = ptHtmlContent;
        }else if(languageType === 'vi_VI'){
            locale = 'vi_VI'
            htmlContent = viHtmlContent;
        }else if(languageType === 'ar_AR'){
            locale = 'ar_AR'
            htmlContent = arHtmlContent;
        }
        this.setState({languageType:locale, htmlContent})
    }

   

    render() {
        const { show } = this.props;
        console.log('data:',show);  
        return (
            
           <div style={{width:'100%', height:'100%'}}>
             {/* <iframe title='title' id="myframe" src={`https://itms-h5.sany.com.cn/#/pages/login/syprivacypolicy?language=${this.state.languageType}`} width="100%" height="100%" frameborder="0" scrolling="no" ></iframe> */}
             <iframe
                    title="html-preview"
                    width="100%" height="100%"
                    frameborder="0"
                    sandbox="allow-same-origin allow-scripts allow-forms"
                    srcDoc={this.state.htmlContent}
            />
           </div> 

        )
    }
}

export default PrivacyAgreement = withTranslation()(PrivacyAgreement);